import React from 'react'
import BlinkingLocationIcon from '../screens/Carpools/Components/BlinkingLocationIcon'


const styles = { 
  search:{
    height: "40px",
    width: "inherit",
    backgroundColor: "#2D2F3C",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    borderRadius: "30px",
    padding: "10px",
    
    
  },
  searchInput: {
    height:"30px",
    border: "none",
    backgroundColor: "#2D2F3C",
    color: "#f0f0f0",
  }
}


//  .search input:hover{
//    border: none,
//  }

const SearchBar = ({onChange,inputRef,locationType,placeholder, disabled,searchValue}) => {
  return (
    <div style={styles.search}>
      {
        locationType && 
        <BlinkingLocationIcon/>
        // <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        // <circle cx="12" cy="12" r="8.5" stroke="#A0A3AF" stroke-width="3"/>
        // <circle cx="12" cy="12" r="5" fill="#A0A3AF"/>
        // </svg>
        
      }
       { !locationType &&<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.3851 15.4458C11.7348 17.5685 7.85535 17.4014 5.39857 14.9446C2.76253 12.3086 2.76253 8.0347 5.39857 5.39866C8.03461 2.76262 12.3085 2.76262 14.9445 5.39866C17.4013 7.85544 17.5684 11.7349 15.4457 14.3852L20.6013 19.5408C20.8942 19.8337 20.8942 20.3086 20.6013 20.6015C20.3085 20.8944 19.8336 20.8944 19.5407 20.6015L14.3851 15.4458ZM6.45923 13.884C4.40898 11.8337 4.40898 8.50957 6.45923 6.45932C8.50948 4.40907 11.8336 4.40907 13.8839 6.45932C15.9326 8.50807 15.9341 11.8288 13.8884 13.8795C13.8868 13.881 13.8853 13.8824 13.8838 13.884C13.8823 13.8855 13.8808 13.887 13.8793 13.8885C11.8287 15.9342 8.50798 15.9327 6.45923 13.884Z" fill="#A0A3AF"/>
        </svg>}
        <input style={styles.searchInput} placeholder={placeholder || 'Search event'} onChange={(e)=>onChange(e)} value={searchValue} disabled={disabled} />
   </div>
  )
}

export default SearchBar
